module.exports = (window.Handlebars["default"] || window.Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "/ticketing/"
    + alias2(alias1(((stack1 = ((stack1 = (data && data.root)) && stack1.bootquery)) && stack1.method), depth0))
    + "/"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.row : depth0)) != null ? stack1.ID : stack1), depth0));
},"useData":true})